function CollectionGrid(props) {
  const attributesToRetrieve = ["title", "content"];
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [intersected, setIntersected] = React.useState(true);
  const queryFromURL = window.location.href.indexOf("search?q=") > 0 ? decodeURI(window.location.href.substring(window.location.href.indexOf("search?q=") + 9)) : "";
  const [searchState, setSearchState] = React.useState({
    query: queryFromURL,
    page: 1
  });
  const [showDisclaimer, setShowDisclaimer] = React.useState(false);
  const [finaleSaleDisclaimer, setFinalSaleDisclaimer] = React.useState(false);
  const sentinel = React.useRef();
  onSentinelIntersection2 = entries => {
    // console.log('top ', entries)
    entries.forEach(entry => {
      entry.isIntersecting ? setIntersected(true) : setIntersected(false);
    });
  };
  React.useEffect(() => {
    let pathname = window.location.pathname;
    if (pathname.search('outlet') !== -1) {
      setShowDisclaimer(true);
      setFinalSaleDisclaimer(true);
    }

    // if(pathname.search('bucket-sale') !== -1 || pathname.search('end-of-year-sale-5')) {
    //   setFinalSaleDisclaimer(true);
    // }
  }, []);
  React.useEffect(() => {
    let observer2 = new IntersectionObserver(onSentinelIntersection2);
    observer2.observe(sentinel.current);
    return () => observer2.disconnect();
  }, [props]);
  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);
  function stateCh(updatedSearchState) {
    if (intersected) {
      let ll = {
        ...updatedSearchState
      };
      ll.page = 1;
      setSearchState(ll);
    } else {
      setSearchState(updatedSearchState);
    }
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    ref: sentinel,
    className: "titleOnTop"
  }, props.collection ? props.collection : "SEARCH"), showDisclaimer && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "Discalimer"
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "#B30000"
    }
  }, "*NOTE: INTERNATIONAL SHIPPING"), " THIS OFFER CANNOT BE COMBINED WITH DISCOUNT CODES OR OTHER PROMOTIONS. NO EXCHANGES, RETURNS, OR REFUNDS. ONLY APPLICABLE TO THE CONTIGUOUS UNITED STATES. LIMITED TIME ONLY & SUBJECT TO AVAILABILITY."), /*#__PURE__*/React.createElement("p", {
    className: "Discalimer",
    style: {
      padding: '1rem 0'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "#B30000"
    }
  }, "*FINAL SALE ITEMS:"), " NO EXCHANGES, RETURNS, OR REFUNDS. CANNOT BE COMBINED WITH DISCOUNT CODES OR OTHER PROMOTIONS. SUBJECT TO AVAILABILITY.")), /*#__PURE__*/React.createElement(InstantSearch, {
    searchState: searchState,
    onSearchStateChange: stateCh,
    indexName: "a_products",
    searchClient: searchClient
  }, props.handle ? null : /*#__PURE__*/React.createElement(Index, {
    indexName: "a_products_query_suggestions"
  }, /*#__PURE__*/React.createElement(Configure, {
    hitsPerPage: windowWidth > 700 ? 5 : 3,
    clickAnalytics: true,
    userToken: aa('getUserToken', null, (err, userToken) => {
      if (err) {
        console.error(err);
        return;
      }
      return userToken;
    })
  })), /*#__PURE__*/React.createElement(Index, {
    indexName: "a_products"
  }, /*#__PURE__*/React.createElement(Configure, {
    ruleContexts: "SearchPage",
    filters: props.handle ? `collections:${props.handle}` : ``,
    hitsPerPage: 16,
    clickAnalytics: true,
    userToken: aa('getUserToken', null, (err, userToken) => {
      if (err) {
        console.error(err);
        return;
      }
      return userToken;
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "activeFiltersAndButton"
  }, /*#__PURE__*/React.createElement(CustomCurrentRefinements, null), /*#__PURE__*/React.createElement(ClearRefinements, null)), windowWidth < 800 ? /*#__PURE__*/React.createElement(ReactDrawer, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "mobileFilters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "activeFiltersAndButton"
  }, /*#__PURE__*/React.createElement(CustomCurrentRefinements, null), /*#__PURE__*/React.createElement(ClearRefinements, null)), /*#__PURE__*/React.createElement("h1", {
    style: {
      textAlign: 'center',
      fontWeight: '500'
    }
  }, "Filter by"), /*#__PURE__*/React.createElement(Collapsible, {
    title: "Size"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "option2"
  })), /*#__PURE__*/React.createElement(Collapsible, {
    title: "Color"
  }, /*#__PURE__*/React.createElement(ColorRefinementList, {
    attribute: "named_tags.color",
    limit: 15
  })), props.handle ? null : /*#__PURE__*/React.createElement(Collapsible, {
    title: "Gender"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.gender",
    limit: 2
  })), /*#__PURE__*/React.createElement(Collapsible, {
    title: "Fit"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.fit"
  })), /*#__PURE__*/React.createElement(Collapsible, {
    title: "Type"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.type",
    limit: 23
  })), /*#__PURE__*/React.createElement(Collapsible, {
    title: "Technology"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.technology",
    limit: 22
  })), /*#__PURE__*/React.createElement(Collapsible, {
    title: "Price"
  }, /*#__PURE__*/React.createElement(RangeInput, {
    attribute: "price"
  })), /*#__PURE__*/React.createElement(SortBy, {
    defaultRefinement: "a_products",
    items: [{
      value: 'a_products',
      label: 'Sort by'
    }, {
      value: 'a_products_price_desc',
      label: 'Price: High-Low'
    }, {
      value: 'a_products_price_asc',
      label: 'Price: Low-High'
    }]
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "desktopFilters"
  }, " ", /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Size"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "option2"
  })), /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Color"
  }, /*#__PURE__*/React.createElement(ColorRefinementList, {
    attribute: "named_tags.color",
    limit: 15
  })), props.handle ? null : /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Gender"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.gender",
    limit: 2
  })), /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Fit"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.fit"
  })), /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Type"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.type",
    limit: 23
  })), /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Technology"
  }, /*#__PURE__*/React.createElement(CustomRefinementList, {
    attribute: "named_tags.technology",
    limit: 22
  })), /*#__PURE__*/React.createElement(ReactDropDown, {
    header: "Price"
  }, /*#__PURE__*/React.createElement(RangeInput, {
    attribute: "price"
  })), /*#__PURE__*/React.createElement(SortBy, {
    defaultRefinement: "a_products",
    items: [{
      value: 'a_products',
      label: 'Sort by'
    }, {
      value: 'a_products_price_desc',
      label: 'Price: High-Low'
    }, {
      value: 'a_products_price_asc',
      label: 'Price: Low-High'
    }]
  }))), /*#__PURE__*/React.createElement("div", {
    className: "searchInputContainer"
  }, /*#__PURE__*/React.createElement(SearchBox, {
    showLoadingIndicator: true,
    searchAsYouType: true,
    autoFocus: true,
    reset: /*#__PURE__*/React.createElement("div", null, "Clear"),
    submit: /*#__PURE__*/React.createElement("div", null)
  })), props.handle ? /*#__PURE__*/React.createElement("div", {
    className: "pad",
    style: {
      paddingTop: "10px"
    }
  }) : /*#__PURE__*/React.createElement(CustomAutocomplete, null), /*#__PURE__*/React.createElement("div", {
    "data-insights-index": INDEX_NAME
  }, /*#__PURE__*/React.createElement(CustomInfiniteHits, {
    windowWidth: windowWidth
  }))));
}
const completeTheLook = document.getElementById('reactCollection');
if (completeTheLook) {
  const completeTheLookRoot = ReactDOM.createRoot(completeTheLook);
  completeTheLookRoot.render( /*#__PURE__*/React.createElement(CollectionGrid, {
    handle: completeTheLook.dataset.collectionHandle,
    collection: completeTheLook.dataset.collection
  }));
} else {
  console.log('#complete-the-look not found');
}
